import React from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from './components/Spinner';
import { consumeReturnTo } from '../utils/sessionUtils';

const LoginOnProgress = ({connecting, loginFunc}) => {
    const navigate = useNavigate();
    React.useEffect(()=> {
      if (connecting) {
        const hash = window.location.hash;
        if (hash) {
            const params = new URLSearchParams(hash.substring(1));
            const accessToken = params.get('access_token');
            if (accessToken) {
                fetch('/login?accessToken=' + accessToken, {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                }).then(response => response.json())
                  .then(async data => {
                    // Esperamos a que se refresque la sesión: si navegamos antes,
                    // isAuthenticated sigue en false y ProtectedRoute nos echaría.
                    if (loginFunc) {
                      await loginFunc();
                    }
                    navigate(consumeReturnTo() || '/myAccount');
                  });
            }
        }
      }
    }, [connecting, loginFunc]);
    return (
        <Spinner />
    )
}

export default LoginOnProgress;